<cache-date></cache-date>


<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>


<br>

<div class="row">
	<div class="col-sm-4 col-md-3">
		<span
			class="button-download-link float-left"
			(click)="downloadCSV()"
			[sextant]="'download_csv'"
		>
			<i class="fa fa-download" aria-hidden="true"></i> CSV
		</span>
	</div>
</div>

<loading [isLoad]="statsLoader"></loading>
<table class="table table-bordered" [sextant]="'stats'" [url]="filter.currentUrl">
	<thead>
		<tr>
			<th>{{ 'adminstat.common.country' | translate }}</th>
			<th>{{ 'adminstat.users.reg_day.countReg' | translate }}</th>
			<th>{{ 'adminstat.filterForm.isOrWasPaidMode' | translate }}</th>
			<th>%</th>
		</tr>
	</thead>
	
	<tbody>
		<tr *ngFor="let stat of stats">
			<td>
				<p *ngIf="expandCountry[stat.location]">
					<ngb-accordion #acc="ngbAccordion"  (click)="showRegionList(stat)"  *ngIf="expandCountry[stat.location]">
						<ngb-panel title="{{ countriesMap[stat.location] || 'adminstat.common.not found' | translate }}">
							<ng-template ngbPanelContent>
								<loading [isLoad]="regionLoaders[stat.location]"></loading>
								
								<table class="table">
									<thead>
									<tr>
										<th>{{ 'common.domains.buy domain section.region' | translate }}</th>
										<th>{{ 'adminstat.users.reg_day.countReg' | translate }}</th>
										<th>{{ 'adminstat.filterForm.isOrWasPaidMode' | translate }}</th>
										<th>%</th>
									</tr>
									</thead>
									
									<tbody>
									<tr *ngFor="let region of stat.regionList">
										<td>{{ region.location }}</td>
										<td>
											{{ region.userCount }}
										</td>
										
										<td>
											{{ region.userPaidCount }}
										</td>
										
										<td>
											{{ region.conversion | numberFormat: '1.2-2' }}
										</td>
									</tr>
									</tbody>
								</table>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</p>
				<ng-template [ngIf]="!expandCountry[stat.location]">
					{{ countriesMap[stat.location] || 'adminstat.common.not found' | translate }}
				</ng-template>
			</td>
			
			<td>
				{{ stat.userCount }}
			</td>
			
			<td>
				{{ stat.userPaidCount }}
			</td>
			
			<td>
				{{ stat.conversion | numberFormat: '1.2-2' }}
			</td>
		</tr>
	</tbody>
</table>
